import { currenciesListOptions } from '@crm/api'
import { useQuery } from '@tanstack/react-query'

export const useDefaultCurrency = () => {
  const { data: currencyData } = useQuery({
    ...currenciesListOptions({
      query: { page: 1, per_page: 1, ordering: '-is_default' }
    })
  })

  const currencyResults = currencyData?.results?.[0]

  const defaultCurrency = currencyResults?.is_default
    ? currencyResults.id
    : undefined

  return { defaultCurrency }
}
